export class Logger {
  public constructor(private readonly enabled: boolean) {}

  public warn(message: string, context?: unknown): void {
    if (this.enabled) console.warn(`[Retro Space Fight] ${message}`, context ?? '');
  }

  public error(message: string, context?: unknown): void {
    if (this.enabled) console.error(`[Retro Space Fight] ${message}`, context ?? '');
  }
}
